import { render, staticRenderFns } from "./pagings.vue?vue&type=template&id=28c72196&scoped=true&"
import script from "./pagings.vue?vue&type=script&lang=js&"
export * from "./pagings.vue?vue&type=script&lang=js&"
import style0 from "./pagings.vue?vue&type=style&index=0&id=28c72196&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c72196",
  null
  
)

export default component.exports